import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=3e0e7842&scoped=true"
import script from "./Detalhes.vue?vue&type=script&lang=ts"
export * from "./Detalhes.vue?vue&type=script&lang=ts"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=3e0e7842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e7842",
  null
  
)

export default component.exports